import 'jquery';
import 'isotope-layout';
import { getCssVar } from '../util/cssVars';
// import "../util/isotopeNoLayout";

export default {
  elements: [],
  data: {
    forms: {},
  },
  init() {
    this.initElements();
  },
  initElements() {
    this.queryElements();

    this.initFilter();
  },
  queryElements() {
    this.elements.isotopes = document.querySelectorAll('.isotope, [data-isotope]');
  },
  initFilter() {
    this.elements.isotopes.forEach(iso => {
      const $iso = $(iso);

      $iso.on('arrangeComplete', function(event, filteredItems) {
        $('.odd', $iso).removeClass('odd');

        if (filteredItems.length) {
          let j = 0;
          $(filteredItems).each((i, object) => {
            if (j++ % 2 === 0) {
              $(object.element).addClass('odd');
            }
            if (j >= filteredItems.length - 1) {
              $iso.removeClass('is-loading');
            }
          });
        } else {
          $iso.removeClass('is-loading');
        }
      });

      $('.order-lg-first', $iso).removeClass('order-lg-first');

      // Filters
      const $filters = $iso.prev('.filter');
      $filters.on('click', '[data-filter], .filter', function() {
        const $element = $(this);
        let filterValue;
        if ($element.is('.active')) {
          // uncheck
          filterValue = '*';
        } else {
          filterValue = $element.data('filter');
          $filters.find('.active').removeClass('active');
        }
        $iso.addClass('is-loading');
        $element.toggleClass('active');
        setTimeout(() => {
          $iso.data('isotope').arrange({
            filter: filterValue,
          });
          $filters.toggleClass('open');
          const offset = parseFloat(getCssVar('--fullheight-offset') || 0, 10);
          $('html, body')
            .stop()
            .animate({ scrollTop: $iso.offset().top - offset }, 500);
        }, 300);
      });
      $filters.on('click', '[data-toggle]', function() {
        $filters.toggleClass('open');
      });
      // Use hash for prefiltering
      if (window.location.hash) {
        $(`[data-filter="${window.location.hash.replace(/^#/, '.')}"]`, $filters).trigger('click');
      }
    });
  },
  finalize() {
    this.elements.isotopes.forEach(iso => {
      const $iso = $(iso);
      setTimeout(() => {
        $iso.data('isotope').arrange();
      }, 300);
    });
  },
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/routes/hasIsotope.js